import React from 'react';
import { Route, Switch } from 'react-router-dom';
import OrderDetails from '../../../OrderDetails/index';

export default () => (
  <Switch>
    <Route exact path="/viewOrder" component={OrderDetails} />
  </Switch>
);
